import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const aboutOrgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '开云体育平台',
    url: 'https://www.kaiyunsports.com',
    description: '开云体育平台是专业的在线体育竞技服务平台，覆盖足球、篮球、网球等数百种赛事。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      email: 'service@kaiyunsports.com',
      availableLanguage: ['Chinese', 'English'],
    },
  };

  const aboutWebPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于开云体育平台 - 专业体育竞技服务平台',
    description: '了解开云体育平台的品牌历史、平台信誉、核心优势和联系方式。',
    url: 'https://www.kaiyunsports.com/about',
  };

  const milestones = [
    { year: '2018', title: '平台创立', desc: '开云体育平台正式成立，获得菲律宾博彩监管牌照，开启专业体育竞技服务' },
    { year: '2019', title: '技术升级', desc: '完成核心系统架构升级，支持百万级用户并发访问，推出移动端服务' },
    { year: '2020', title: '全球拓展', desc: '业务覆盖超过100个国家和地区，用户数量突破500万' },
    { year: '2021', title: '产品矩阵', desc: '推出APP客户端，覆盖足球、篮球、网球、电竞等全部主流体育项目' },
    { year: '2022', title: '合作深化', desc: '与英超、NBA、西甲等顶级联赛达成官方数据合作，服务持续升级' },
    { year: '2023', title: '行业领先', desc: '全球注册用户突破2000万，成为亚洲最具影响力的体育服务平台之一' },
    { year: '2024', title: '智能升级', desc: '引入AI智能分析系统，全面提升用户体验和服务精准度' },
    { year: '2025', title: '生态构建', desc: '构建完整体育服务生态，用户突破2800万，覆盖全球200+国家和地区' },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutOrgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutWebPageSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-20">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>

            <section className="mb-16">
              <div className="text-center mb-10">
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                  关于开云体育平台
                </h1>
                <p className="mt-4 text-foreground-500 max-w-[700px] mx-auto leading-relaxed">
                  开云体育平台自2018年创立以来，始终秉承"专业、安全、诚信"的服务理念，致力于为全球体育爱好者提供顶级的在线体育竞技服务体验。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12">
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-flag-line text-2xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-800">品牌使命</h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">打造全球最值得信赖的体育竞技服务平台，让每一位体育爱好者都能享受专业、安全、便捷的服务体验</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-eye-line text-2xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-800">品牌愿景</h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">成为全球体育爱好者首选的综合性体育服务平台，以技术创新和服务品质引领行业发展</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                    <i className="ri-shield-star-line text-2xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-800">核心价值观</h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">专业至上、用户为本、诚信经营、持续创新，始终将用户体验和资金安全放在首位</p>
                </div>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
                发展历程
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {milestones.map((m, i) => (
                    <div key={i} className={`relative flex items-start gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'} pl-12 md:pl-0`}>
                        <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 inline-block max-w-[400px]">
                          <span className="text-xs font-bold text-primary-600">{m.year}</span>
                          <h3 className="font-heading text-base font-semibold text-foreground-800 mt-1">{m.title}</h3>
                          <p className="text-sm text-foreground-500 mt-1.5">{m.desc}</p>
                        </div>
                      </div>
                      <div className="absolute left-0 md:left-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 -translate-x-1/2 z-10">
                        <i className="ri-check-line"></i>
                      </div>
                      <div className="flex-1 hidden md:block"></div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
                平台信誉与资质
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-government-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-800">合法牌照</h3>
                  <p className="mt-2 text-sm text-foreground-500">持有菲律宾博彩监管区合法运营牌照，受国际权威机构监管</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-lock-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-800">数据加密</h3>
                  <p className="mt-2 text-sm text-foreground-500">采用256位SSL加密技术，确保用户数据和交易信息绝对安全</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                    <i className="ri-scales-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-800">公平公正</h3>
                  <p className="mt-2 text-sm text-foreground-500">所有赛事数据由国际权威数据商提供，确保赔率公正透明</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-hand-heart-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-800">责任博彩</h3>
                  <p className="mt-2 text-sm text-foreground-500">积极倡导责任博彩理念，提供多项用户保护措施和自我限制工具</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[800px] mx-auto">
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800">客服热线</h3>
                    <p className="mt-1 text-sm text-foreground-500">400-888-9999</p>
                    <p className="text-xs text-foreground-400 mt-1">7×24小时全天候服务</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800">电子邮箱</h3>
                    <p className="mt-1 text-sm text-foreground-500">service@kaiyunsports.com</p>
                    <p className="text-xs text-foreground-400 mt-1">24小时内回复</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800">公司地址</h3>
                    <p className="mt-1 text-sm text-foreground-500">菲律宾马尼拉博彩监管区</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800">服务时间</h3>
                    <p className="mt-1 text-sm text-foreground-500">7×24小时全天候在线</p>
                    <p className="text-xs text-foreground-400 mt-1">全年无休，随时为您服务</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}